/**
 * CertificationVisual
 * 
 * Displays the appropriate certification video based on lot status (RDS, GRS).
 * Extracted from legacy App.js/MainRight.js logic.
 */

export const CertVisual = ({ activeSection, isGRS, t }) => { // <<< MODIFIED PROPS
  // This component might need more props like 'origin' or 'down_type' if the videos vary by those too.
  // For now, it's based on 'isGRS' passed directly.
  // The legacy code also had logic for 'cert-upper-grs.mp4' vs 'cert-upper.mp4'.

  // const isGRS = recycled; // NO LONGER NEEDED

  
  // The legacy MainRight also had specific videos for 'cert-upper-grs.mp4' and 'cert-upper.mp4'.
  // This assumes 'recycled' implies GRS and uses 'cert-upper-grs.mp4'.
  // If 'recycled' is false, it falls back to 'cert-upper.mp4'.
  // Note: The legacy code also has conditional logic for activeSection, but here we're focused on the visual itself.
  
  return (
    <>
      <div className="vidWrap">
        <video 
          className="il-add" 
          data-beta-flow="true" 
          src={isGRS ? "/img/cert/cert-upper-grs.mp4" : "/img/cert/cert-upper.mp4"} 
          muted={true} 
          preload="true" 
          autoPlay={true} 
          loop={true}
        ></video>
      </div>
    </>
  );
};
